import React, { useState } from 'react';
import {
	View,
	TextInput,
	TouchableOpacity,
	StyleSheet,
} from 'react-native';
import { Feather } from '@expo/vector-icons';
import PasswordValidation from './PasswordValidation';

interface AuthenticationTextInputProps {
	onChangeText: (text: string) => void;
	placeholder: string;
	secureTextEntry?: boolean;
	toggleVisibility?: () => void;
	isVisible?: boolean;
	password: string;
	confirmPassword?: string;
	zIndex: number;
	showValidation?: boolean;
}

const AuthenticationTextInput: React.FC<AuthenticationTextInputProps> = ({
	onChangeText,
	placeholder,
	secureTextEntry = false,
	toggleVisibility,
	isVisible,
	password,
	confirmPassword,
	zIndex,
	showValidation,
}) => {
	const [isFocused, setIsFocused] = useState(false);

	return (
		<View style={[styles.input, { zIndex }]}>
			<TextInput
				secureTextEntry={secureTextEntry}
				style={styles.textInput}
				placeholder={placeholder}
				autoCapitalize="none"
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				onChangeText={onChangeText}
			/>
			{toggleVisibility && (
				<TouchableOpacity
					style={styles.toggleVisibility}
					onPress={toggleVisibility}
				>
					<Feather name={isVisible ? 'eye' : 'eye-off'} size={20} color="white" />
				</TouchableOpacity>
			)}
			{isFocused && showValidation && (
				<PasswordValidation password={password} confirmPassword={confirmPassword} />
			)}
		</View>
	);
};

const styles = StyleSheet.create({
	input: {
		width: '80%',
		borderBottomWidth: 1,
		borderBottomColor: 'white',
		minHeight: 40,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignContent: 'center',
		position: 'relative',
	},
	textInput: {
		width: '100%',
		height: '100%',
		color: 'white',
		fontSize: 16,
	},
	toggleVisibility: {
		position: 'absolute',
		right: 5,
		top: 9.5,
	},
});

export default AuthenticationTextInput;
